var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.391,
    height: 15.767,
    viewBox: "0 0 14.391 15.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-trash",
    "data-name": "Icon feather-trash",
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12106",
    "data-name": "Path 12106",
    d: "M4.5,9H16.891",
    transform: "translate(0 -3.247)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12107",
    "data-name": "Path 12107",
    d: "M17.137,5.753v9.637a1.377,1.377,0,0,1-1.377,1.377H8.877A1.377,1.377,0,0,1,7.5,15.391V5.753m2.065,0V4.377A1.377,1.377,0,0,1,10.942,3H13.7a1.377,1.377,0,0,1,1.377,1.377V5.753",
    transform: "translate(-1.623 0)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.569871fde8086e53f5c35898f3dbc006.svg";
export { ForwardRef as ReactComponent };